
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { DtoService } from '../app/service/dto.service';
import { UtilService } from '../app/service/util.service';
import { FunctService } from '../app/service/funct.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { ToastrModule } from 'ngx-toastr';
import { NgxSpinnerModule } from "ngx-spinner";
import { LocalStorageService, NgxWebstorageModule } from 'ngx-webstorage';
import { FormsModule, ReactiveFormsModule} from '@angular/forms';
import { ModalModule, BsModalService } from 'ngx-bootstrap/modal';
import { HomeComponent } from './component/home/home.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Injector, APP_INITIALIZER } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LOCATION_INITIALIZED } from '@angular/common';
import { CommonService } from './service/common.service';
import { NavigationService } from '../app/service/navigation.service';
import { TwodLiveComponent } from './component/twod-live/twod-live.component';


// export function appInitializerFactory(translate: TranslateService, injector: Injector,) {
//   return () => new Promise<any>((resolve: any) => {
//     const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
//     locationInitialized.then(() => {
//       let lang=localStorage.getItem('ngx-webstorage|locallanguage');
//       let langToSet;
//       // console.log(lang)
//       if(lang == null){
//         langToSet = 'my';
//       }
//       else{
//         langToSet=lang.toString().replace(/['"]+/g, '')
//       }    
//       translate.setDefaultLang(langToSet);
//       translate.use(langToSet).subscribe(() => {
//         //console.info(`Successfully initialized '${langToSet}' language.'`);
//       }, err => {
//        // console.error(`Problem with '${langToSet}' language initialization.'`);
//       }, () => {
//         resolve(null);
//       });
//     });
//   });
// }

@NgModule({
  declarations: [ 
    AppComponent,    
    HomeComponent,   
    TwodLiveComponent
  ],
  imports: [ 
   
    ModalModule.forRoot(),    
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: (http:HttpClient) => { return new TranslateHttpLoader(http, './assets/i18n/', '.json');},
          deps: [HttpClient]         
      }
    }),
    CarouselModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    NgxSpinnerModule,
    HttpClientModule,
    NgxWebstorageModule.forRoot(),
    IonicModule,
    NgxSpinnerModule,
   
  ],
  providers: [
    NavigationService,
    DtoService,
    UtilService,
    FunctService,
    DatePipe,   
    BsModalService,    
    CommonService,   
   
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }

